import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';

import BaseAnalytics from './base-analytics';

// params
const EARNINGS = 'earnings';
const NAME = 'name';
const PROJECTS_COMPLETED = 'projectCount';
const START_DATE = 'startDate';
const SLUG = 'slug';

const FACTOID_TOTAL_ADDED = 'Total Added YTD';
const FACTOID_TOTAL_HIRED = 'Total Hired YTD';

const LIMIT = 10;

export default BaseAnalytics.extend({
  session: service(),
  store: service(),
  currentUser: readOnly('session.currentUser'),

  ////////////
  // CONFIG //
  ////////////
  title: computed('year', 'limit', function() {
    const year = this.get('year');
    if (!year) {
      return 'Top Creator Payments';
    }
    const dateString = (year === new Date().getFullYear()) ? 'YTD' : year;

    const limit = this.get('limit');
    return `Top ${limit} Creator Payments - ${dateString}`;
  }),

  factoidType: 'freelancer',
  annual: true,
  allowTableDownload: true,
  defaultFileName: computed('year', function() {
    const year = this.get('year');
    return `Glimmer_Creator_Report_${year}.csv`;
  }),

  ///////////
  // CHART //
  ///////////
  limit: computed('data.length', function() {
    const dataCount = this.get('data.length');
    return Math.min(LIMIT, dataCount);


  }), // limit to top x freelancers for chart

  chartLabelParam: NAME,
  chartKeyParam: SLUG,

  chartSumParams: [{
    label: 'Earnings',
    value: EARNINGS,
    defaultParam: true
  }],

  chartLabels: computed('chartData', 'chartKeyParam', function() {
    const data = this.get('chartData');
    const keyParam = this.get('chartKeyParam');

    return data.reduce((labels, item) => {
      labels[item.get(keyParam)] = item.get(NAME);

      return labels;
    }, {});
  }),

  chartData: computed('data', 'limit', function() {
    const data = Array.from(this.get('data'));
    const limit = this.get('limit');

    data.sort((a, b) => a.get(EARNINGS) > b.get(EARNINGS) ? -1 : 1);
    return data.slice(0, limit);
  }),

  chartSumFormatter: computed('sumParam', function() {
    const sumParam = this.get('sumParam');
    switch (sumParam) {
      case EARNINGS:
        return this.formatMoneyWithoutChange.bind(this);
      default:
        return null;
    }
  }),

  ///////////
  // TABLE //
  ///////////
  tableColumns: computed(function() {
    const formatMoney = this.formatMoney.bind(this);
    return [
      {
        label: 'Creator',
        param: NAME,
        link: (value, model) => `/${model.get(SLUG)}`
      },
      {
        label: 'Payments ($USD)',
        param: EARNINGS,
        sortDescending: true,
        defaultSort: true,
        display: formatMoney
      },
      {
        label: 'Projects Completed',
        param: PROJECTS_COMPLETED,
        sortDescending: true,
      }
    ];
  }),

  //////////////
  // FACTOIDS //
  //////////////
  factoidLayout: [
    [{title: FACTOID_TOTAL_ADDED}, {title: FACTOID_TOTAL_HIRED}]
  ],

  /////////////
  // METHODS //
  /////////////
  queryData(year) {
    const companyId = this.get('currentUser.company.id');
    return this.get('store').query('freelancer-metric', {
      start_at: new Date(year, 0, 1).toISOString(),
      end_at: new Date(year + 1, 0, 1).toISOString(),
      filter: {
        company_id: companyId
      }
    });
  },

  peekData(year) {
    return this.get('store').peekAll('freelancer-metric').filter(item => {
      return item.get(START_DATE).getFullYear() === year;
    });
  }
});
